import { useUserConsentMutation } from '@api/userDetails';
import { TOAST_TYPES } from '@constants/constants';
import { setToastMessage } from '@stores/App/slice';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Hook to handle invite onboarding modal for consent acceptance and newsletter opt ins (invited users flow)
 * - handleContinueOnboarding: Function to handle continue onboarding for accessing the dashboard
 */
const useInviteOnboarding = (user: any, onClose?: () => void) => {
  const [userConsent, { isLoading: isUserConsentLoading }] = useUserConsentMutation();
  const [termsOfServiceAccepted, setTermsOfServiceAccepted] = useState(false);
  const [newsletterOptIn, setnewsletterOptIn] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      setTermsOfServiceAccepted(Boolean(user.termsOfServiceAccepted));
      setnewsletterOptIn(Boolean(user.newsletterOptIn));
    }
  }, [user]);

  const handleContinueOnboarding = async () => {
    if (isUserConsentLoading) {
      return;
    }
    if (!termsOfServiceAccepted) {
      dispatch(
        setToastMessage({
          type: TOAST_TYPES.DEFAULT,
          message: 'You must agree to the Terms of Service and Data Access Terms to continue.',
        }),
      );
      return;
    }
    try {
      await userConsent({
        authorityConsentAccepted: true, // Always true for invited users
        termsOfServiceAccepted,
        newsletterOptIn,
      }).unwrap();
      onClose?.();
    } catch (error) {
      dispatch(
        setToastMessage({
          type: TOAST_TYPES.ERROR,
          message:
            (error as any)?.message || (error as any)?.data?.message || 'Failed to Submit Consent',
        }),
      );
    }
  };

  return {
    handleContinueOnboarding,
    isLoading: isUserConsentLoading,
    termsOfServiceAccepted,
    setTermsOfServiceAccepted,
    newsletterOptIn,
    setnewsletterOptIn,
  };
};

export default useInviteOnboarding;
